module.exports = __webpack_public_path__ + "static/media/map-transparent.489115eb.png";